/**
 * The liveness route of the backend (`GET /liveness`, a static route of the backend framework; the deployment of
 * mma-backend smoke-tests the same route). It is not under `/v1`: the configured endpoint is `/mma/<deployment>/v1`,
 * the route is `/mma/<deployment>/liveness`.
 */
export const livenessUrl = (endpoint: string): string => `${endpoint.replace(/\/+$/, '').replace(/\/v1$/, '')}/liveness`

/**
 * Whether the backend is up: it answers its liveness route with a success status. A gateway that answers for a backend
 * that is down (502, 503, 404) is not "up", and neither is a network failure or a timeout.
 */
export const checkServer = async (endpoint: string | undefined, timeoutMs = 8000): Promise<boolean> => {
    if (!endpoint) return false

    const controller = new AbortController()
    const timer = setTimeout(() => controller.abort(), timeoutMs)

    try {
        const response = await fetch(livenessUrl(endpoint), { cache: 'no-store', signal: controller.signal })
        return response.ok
    } catch {
        return false
    } finally {
        clearTimeout(timer)
    }
}
